export default __webpack_public_path__ + "static/media/serviciosAlarma1Mobile.190cfb24.png";